<template>
  <label class="hs-toggle" :class="{ 'is-disabled': disabled }">
    <button
      type="button"
      class="hs-toggle__switch"
      :class="{ 'is-on': modelValue }"
      :disabled="disabled"
      role="switch"
      :aria-checked="modelValue"
      @click="$emit('update:modelValue', !modelValue)"
    >
      <span />
    </button>
    <span v-if="label || description" class="hs-toggle__content">
      <strong v-if="label">{{ label }}</strong>
      <small v-if="description">{{ description }}</small>
    </span>
  </label>
</template>

<script>
export default {
  name: "HsToggle",
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: "" },
    description: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.hs-toggle {
  align-items: center;
  display: inline-flex;
  gap: 0.75rem;
}

.hs-toggle__switch {
  background: color-mix(in srgb, var(--hs-muted, #64748b) 22%, transparent);
  border-radius: 999px;
  height: 1.8rem;
  padding: 0.18rem;
  transition: background 0.2s ease;
  width: 3.25rem;
}

.hs-toggle__switch span {
  background: #fff;
  border-radius: 999px;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.16);
  display: block;
  height: 1.44rem;
  transition: transform 0.2s ease;
  width: 1.44rem;
}

.hs-toggle__switch.is-on {
  background: linear-gradient(135deg, var(--hs-primary, #3293ec), var(--hs-primary-strong, #1d4ed8));
}

.hs-toggle__switch.is-on span {
  transform: translateX(1.45rem);
}

.hs-toggle__content {
  display: grid;
  gap: 0.15rem;
}

.hs-toggle strong {
  color: var(--hs-text, #0f172a);
  font-size: 0.86rem;
  font-weight: 950;
}

.hs-toggle small {
  color: var(--hs-muted, #64748b);
  font-size: 0.76rem;
  font-weight: 700;
}

.is-disabled {
  opacity: 0.55;
}
</style>
